/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegisteredDevice } from '../../models/registered-device';

export interface GetDevicesByFarm$Params {
  facilityZoneId: number;
}

export function getDevicesByFarm(http: HttpClient, rootUrl: string, params: GetDevicesByFarm$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RegisteredDevice>>> {
  const rb = new RequestBuilder(rootUrl, getDevicesByFarm.PATH, 'get');
  if (params) {
    rb.path('facilityZoneId', params.facilityZoneId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RegisteredDevice>>;
    })
  );
}

getDevicesByFarm.PATH = '/api/regdevice/facilityZoneId/{facilityZoneId}';
